import { View } from 'sierra-ui/primitives'
import styled from 'styled-components'

export const selectSkillSectionPaddingInline = 40

export const SelectSkillSection = styled(View).attrs(() => ({
  paddingLeft: `${selectSkillSectionPaddingInline}`,
  paddingRight: `${selectSkillSectionPaddingInline}`,
}))``
